import {Component, OnInit} from "@angular/core";
import {UserService} from "../../services/users.service";
import {Router} from "@angular/router";
import {Auth2Service} from "../../../../services/auth2.service";
import {LoggedInPageBaseComponent} from "../../../../shared-components/ui-components/logged-in-page-base/logged-in-page-base.component";
import {Title} from "@angular/platform-browser";

@Component({
  selector: 'app-canceled-payment',
  templateUrl: './canceled-payment.component.html',
  styleUrls: ['./canceled-payment.component.scss'],
  standalone: false
})
export class CanceledPaymentComponent extends LoggedInPageBaseComponent implements OnInit {
  breadCrumbs = [
    { iconClass: 'bi-house', path: 'app/users/dashboard'},
    { label: 'Dashboard', path: 'app/users/dashboard'},
    { label: 'Canceled Payment'}
  ];

  showMessages = false;
  messages: any[] = [];
  username: string = '';

  pageName = 'Canceled Payment';


  // @ts-ignore
  constructor(private userService: UserService,
              private routerChild: Router,
              private auth2ServiceChild: Auth2Service,
              private titleService: Title) {
    super(auth2ServiceChild, routerChild);
    this.titleService.setTitle("Scalanthropy Cancelled Payment");
  }

  ngOnInit() {
    this.pageErrorMessages = [];
    //Get the Subscription Prices in a table
    this.username = this.auth2ServiceChild.getUsername();
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" })
    const counterFn = () => {
      this.routerChild.navigateByUrl('app/users/dashboard');
    }
    setTimeout(counterFn, 6000);
  }

  onGoToDashboard(): void {
    this.routerChild.navigateByUrl('app/users/dashboard');
  }
}
